import React, { useEffect, useState, useCallback } from "react";
import { Button, Form } from "react-bootstrap";
import { COLOR_APP, K_LOCAL_STORAGE_SHOP_SETTING_DATA } from "../../constants";
import { useToasts } from 'react-toast-notifications'
import { GET_SETTING_BY_SHOP } from "../../graphql/setting/query";
import { CREATE_SETTING_V2, UPDATE_SETTING_V2 } from "../../graphql/setting/mutation";
import { useLazyQuery, useMutation } from "@apollo/client";
import { SHOP } from "../../graphql/shop/queryShop";
import { UPDATE_SHOP } from "../../graphql/shop/mutation";
import ReactSwitch from "react-switch";

function SettingOther() {
    // Shop id
    const SHOP_ID = localStorage.getItem("SHOP");

    const { addToast } = useToasts()
    const [createSettingV2, { loading: loadingCreateSetting }] = useMutation(CREATE_SETTING_V2)
    const [updateSettingV2, { loading: loadingUpdateSetting }] = useMutation(UPDATE_SETTING_V2)
    const [flowPaymentFirst, setFlowPaymentFirst] = useState(false);
    const [sCodeStartWithO, setSCodeStartWithO] = useState(false);
    const [sp_cod,setSp_cod] = useState(false);
    const [isData, setIsData] = useState(null);
    /**
     * CF auto-payment lives on the SHOP, not the setting document — cf-api gates on
     * shop.isCfPayment — so it is loaded and saved separately from everything else on this
     * page.
     */
    const [isCfPayment, setIsCfPayment] = useState(false);
    /**
     * shop.isContactCapture — reads a buyer's free-text DM and fills in phone, address and
     * courier. Lives on the SHOP like isCfPayment, not on settings, so it loads and saves
     * the same way. Until now it had no UI at all and could only be changed in the database.
     */
    const [isContactCapture, setIsContactCapture] = useState(false);
    /**
     * Which QR the buyer gets: PhaJay-minted (default) or the shop's own bank image.
     * Lives on the SETTING, beside the bankQr image it uses.
     */
    const [cfUseOwnQr, setCfUseOwnQr] = useState(false);
    const [updateShop, { loading: loadingUpdateShop }] = useMutation(UPDATE_SHOP);
    const [getShop, { data: dataGetShop }] = useLazyQuery(SHOP, { fetchPolicy: "cache-and-network" });

    //TODO: GraphQL
    const [getSettings, {loading: loadingGetSettings, data: dataGetSettings}] = useLazyQuery(GET_SETTING_BY_SHOP, { fetchPolicy: "cache-and-network"});

    const fetchSettings = useCallback(async () => {
        try {
            if (!SHOP_ID) {
                addToast("ບໍ່ພົບການຮ້ານຄ້າ", {
                    appearance: 'warning',
                    autoDismiss: true,
                })
                return;
            }        
            if (SHOP_ID) {
                await getSettings({
                    variables: {
                        where: {
                            shop: SHOP_ID,
                        },
                        orderBy: "createdAt_ASC"
                    }
                })
            }
        } catch (error) {
            console.log("Error in setting callback", error);
        }
        
    }, [SHOP_ID, getSettings, addToast]);

    useEffect(() => {
        fetchSettings();
    }, [fetchSettings]);

    useEffect(() => {
        if (SHOP_ID) getShop({ variables: { where: { id: SHOP_ID } } });
    }, [SHOP_ID, getShop]);

    useEffect(() => {
        //* Default OFF. A shop that has never set it must not be asking buyers for money.
        setIsCfPayment(dataGetShop?.shop?.isCfPayment ?? false);
        setIsContactCapture(dataGetShop?.shop?.isContactCapture ?? false);
    }, [dataGetShop]);

    useEffect(() => {
        if (dataGetSettings) {
            setFlowPaymentFirst(dataGetSettings?.settingByShopId?.flowPaymentFirst ?? false);
            setSCodeStartWithO(dataGetSettings?.settingByShopId?.sCodeStartWithO ?? false);
            setSp_cod(dataGetSettings?.settingByShopId?.sp_cod ?? false);
            setCfUseOwnQr(dataGetSettings?.settingByShopId?.cfUseOwnQr ?? false);
            setIsData(dataGetSettings?.settingByShopId);
        }
        localStorage.setItem(K_LOCAL_STORAGE_SHOP_SETTING_DATA, JSON.stringify(dataGetSettings?.settingByShopId));
    }, [dataGetSettings]);

    const _saveCfPayment = async (next) => {
        if (!SHOP_ID) {
            addToast("ບໍ່ພົບການຮ້ານຄ້າ", { appearance: "warning", autoDismiss: true });
            return;
        }
        //* Optimistic, then reconciled from the server below — a switch that does not move
        //* until a round trip finishes reads as broken.
        setIsCfPayment(next);
        try {
            await updateShop({
                variables: { where: { id: SHOP_ID }, data: { isCfPayment: next } },
            });
            await getShop({ variables: { where: { id: SHOP_ID } } });
            addToast(next ? "ເປີດການຮັບເງິນຜ່ານ QR ແລ້ວ" : "ປິດການຮັບເງິນຜ່ານ QR ແລ້ວ",
                { appearance: "success", autoDismiss: true });
        } catch (error) {
            //* Put the switch back where it was: leaving it showing a state the server does
            //* not hold is worse than the failure itself.
            setIsCfPayment(!next);
            addToast("ບັນທຶກບໍ່ສຳເລັດ ກະລຸນາລອງໃໝ່", { appearance: "error", autoDismiss: true });
        }
    };

    const _saveContactCapture = async (next) => {
        if (!SHOP_ID) {
            addToast("ບໍ່ພົບການຮ້ານຄ້າ", { appearance: "warning", autoDismiss: true });
            return;
        }
        //* Optimistic, then reconciled from the server below — a switch that does not move
        //* until a round trip finishes reads as broken.
        setIsContactCapture(next);
        try {
            await updateShop({
                variables: { where: { id: SHOP_ID }, data: { isContactCapture: next } },
            });
            await getShop({ variables: { where: { id: SHOP_ID } } });
            addToast(next ? "ເປີດການຮັບເງິນຜ່ານ QR ແລ້ວ" : "ປິດການຮັບເງິນຜ່ານ QR ແລ້ວ",
                { appearance: "success", autoDismiss: true });
        } catch (error) {
            //* Put the switch back where it was: leaving it showing a state the server does
            //* not hold is worse than the failure itself.
            setIsContactCapture(!next);
            addToast("ບັນທຶກບໍ່ສຳເລັດ ກະລຸນາລອງໃໝ່", { appearance: "error", autoDismiss: true });
        }
    };

    const _saveSetting = async () => {
        if (!SHOP_ID) {
            addToast("ບໍ່ພົບການຮ້ານຄ້າ", {
                appearance: 'warning',
                autoDismiss: true,
            })
            return;
        }  
        if (!isData) {
            await createSettingV2({
                variables: {
                    data: {
                        flowPaymentFirst: flowPaymentFirst,
                        sCodeStartWithO: sCodeStartWithO || false,
                        sp_cod: sp_cod || false,
                        cfUseOwnQr: cfUseOwnQr || false,
                        shop: SHOP_ID
                    }
                }
            })
            fetchSettings()
            addToast("ສ້າງຕັ້ງຄ່າສໍາເລັດ", {
                appearance: 'success',
                autoDismiss: true,
            })
        } else {
            await updateSettingV2({
                variables: {
                    where: {
                        id: isData.id
                    },
                    data: {
                        flowPaymentFirst: flowPaymentFirst,
                        sCodeStartWithO: sCodeStartWithO || false,
                        sp_cod: sp_cod || false,
                        cfUseOwnQr: cfUseOwnQr || false,
                        shop: SHOP_ID
                    }
                }
            })
            fetchSettings()
            addToast("ອັບເດດຕັ້ງຄ່າສໍາເລັດ", {
                appearance: 'success',
                autoDismiss: true,
            })
        }
    }

    return (
        <div>
            {loadingGetSettings ? <div>ກຳລັງໂຫຼດ...</div> : (
                <>
                    <div style={{ padding: 20, paddingBottom: 0, border: "1px solid #ced4da", borderRadius: 5, background: "#fff", margin: 10 }}>
                        {/* //TODO Setting Auto Reply Order Confirm */}
                        <h5 style={{ color: "#1b1b1b", fontWeight: "bold" }}> ຕັ້ງຄ່າການ payment ອໍໂຕ ສຳລັບ ເຊວເພສ <span role="img" aria-label="auto-receive">💵💵</span></h5>
                        <div className="row">
                            <div className="col-6">
                                
                                <Form.Group style={{ display: "flex", flexDirection: 'column' }}>
                                    <h7 style={{ fontWeight: 'bold' }}>ໃຊ້ງານ: <span style={{ fontWeight: 'normal', color: flowPaymentFirst ? "green" : "red" }}>{flowPaymentFirst ? "ເປີດ" : "ປີດ"}</span></h7>
                                    <ReactSwitch
                                        checked={flowPaymentFirst}
                                        onChange={() => setFlowPaymentFirst(!flowPaymentFirst)}
                                        onColor="#bfbdc7"
                                        onHandleColor="#422f90"
                                        handleDiameter={20}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                        height={28}
                                        width={55}
                                        className="react-switch"
                                        id="material-switch"
                                    />
                                </Form.Group>
                                <div style={{ height: 20 }} />
                                <div style={{}}>
                                    <Button style={{ background: COLOR_APP, color: "#ffff", width: "100%" }} onClick={_saveSetting}
                                        disabled={loadingCreateSetting || loadingUpdateSetting} >
                                        {loadingCreateSetting || loadingUpdateSetting ? "ກຳລັງບັນທຶກ..." : "ບັນທຶກ"}
                                    </Button>
                                </div>
                            </div>
                            <div className="col-6">
                                <h7>ຄໍາແນະນໍາການຕັ້ງຄ່າ</h7>
                                <p style={{ margin: 0, fontSize: 14, }}>-ຖ້າຫາກຕັ້ງຄ່ານີ້ເປີດ: ສຳລັບ ເຊວເພສ  ຈະເປັນລາຍລະອຽດການສັ່ງອໍເດີ ທີ່ຕ້ອງໄດ້ຈ່າຍເງີນກ່ອນການ ກ໊ອກຂໍ້ມູນສ່ວນຕົວ</p>
                                <p style={{ margin: 0, fontSize: 14, }}>-ຖ້າຫາກຕັ້ງຄ່ານີ້ປີດ: ສຳລັບ ເຊວເພສ  ຈະເປັນລາຍລະອຽດການສັ່ງອໍເດີ ທີ່ຕ້ອງໄດ້ກ້ອກຂໍ້ມູນສ່ວນຕົວ ໃຫ້ຄົບກ່ອນການຊຳລະເງີນ</p>
                            </div>
                        </div>
                        <div style={{ height: 20 }} />
                    </div>
                    {/* The CF USP: read the buyer's free text so nobody types an address. */}
                    <div style={{ padding: 20, paddingBottom: 0, border: "1px solid #ced4da", borderRadius: 5, background: "#fff", margin: 10 }}>
                        <h5 style={{ color: "#1b1b1b", fontWeight: "bold" }}> ອ່ານເບີ ແລະ ທີ່ຢູ່ຈາກແຊັດອັດຕະໂນມັດ <span role="img" aria-label="chat">💬📍</span></h5>
                        <div className="row">
                            <div className="col-6">
                                <Form.Group style={{ display: "flex", flexDirection: "column" }}>
                                    <h7 style={{ fontWeight: "bold" }}>ໃຊ້ງານ: <span style={{ fontWeight: "normal", color: isContactCapture ? "green" : "red" }}>{isContactCapture ? "ເປີດ" : "ປີດ"}</span></h7>
                                    <ReactSwitch
                                        checked={isContactCapture}
                                        disabled={loadingUpdateShop}
                                        onChange={(next) => _saveContactCapture(next)}
                                        onColor="#bfbdc7"
                                        onHandleColor="#422f90"
                                        handleDiameter={20}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                        height={28}
                                        width={55}
                                        className="react-switch"
                                        id="material-switch-contact-capture"
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-6">
                                <h7>ຄໍາແນະນໍາການຕັ້ງຄ່າ</h7>
                                <p style={{ margin: 0, fontSize: 14 }}>-ຖ້າເປີດ: ລູກຄ້າພິມເບີ ແລະ ທີ່ຢູ່ມາໃນແຊັດ ລະບົບຈະອ່ານ ແລະ ຕື່ມໃສ່ອໍເດີ້ໃຫ້ເອງ ບໍ່ຕ້ອງໃຫ້ແອັດມິນພິມ</p>
                                <p style={{ margin: 0, fontSize: 14 }}>-ຖ້າລະບົບບໍ່ແນ່ໃຈ ຈະຖາມລູກຄ້າໃຫ້ກົດຢືນຢັນ ບໍ່ເດົາເອງ</p>
                                <p style={{ margin: 0, fontSize: 14 }}>-ຖ້າປິດ: ຕ້ອງພິມເບີ ແລະ ທີ່ຢູ່ເອງຄືເກົ່າ</p>
                            </div>
                        </div>
                    </div>

                    {/* //TODO CF auto payment via PhaJay */}
                    <div style={{ padding: 20, paddingBottom: 0, border: "1px solid #ced4da", borderRadius: 5, background: "#fff", margin: 10 }}>
                        <h5 style={{ color: "#1b1b1b", fontWeight: "bold" }}> ຮັບເງິນອັດຕະໂນມັດຜ່ານ QR ໃນແຊັດ (CF) <span role="img" aria-label="qr">📲💵</span></h5>
                        <div className="row">
                            <div className="col-6">
                                <Form.Group style={{ display: "flex", flexDirection: "column" }}>
                                    <h7 style={{ fontWeight: "bold" }}>ໃຊ້ງານ: <span style={{ fontWeight: "normal", color: isCfPayment ? "green" : "red" }}>{isCfPayment ? "ເປີດ" : "ປີດ"}</span></h7>
                                    <ReactSwitch
                                        checked={isCfPayment}
                                        disabled={loadingUpdateShop}
                                        onChange={(next) => _saveCfPayment(next)}
                                        onColor="#bfbdc7"
                                        onHandleColor="#422f90"
                                        handleDiameter={20}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                        height={28}
                                        width={55}
                                        className="react-switch"
                                        id="material-switch-cf-payment"
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-6">
                                <h7>ຄໍາແນະນໍາການຕັ້ງຄ່າ</h7>
                                <p style={{ margin: 0, fontSize: 14 }}>-ຖ້າເປີດ: ຫຼັງລູກຄ້າ CF ແລ້ວ ຈະມີປຸ່ມ “ຮັບ QR ຈ່າຍເງິນ” ໃນແຊັດ ແລະ ລະບົບຈະຢືນຢັນການຈ່າຍໃຫ້ອັດຕະໂນມັດ</p>
                                <p style={{ margin: 0, fontSize: 14 }}>-ຖ້າປິດ: ບິນຈະເປັນຄືເກົ່າ ບໍ່ມີປຸ່ມຈ່າຍເງິນ</p>
                                <p style={{ margin: 0, fontSize: 14 }}>-ຮ້ານທີ່ເກັບເງິນປາຍທາງ (COD) ບໍ່ຈຳເປັນຕ້ອງເປີດ</p>
                            </div>
                        </div>
                        <div style={{ height: 20 }} />
                    </div>
                    {/* //TODO Which QR the CF pay button sends */}
                    {isCfPayment ? (
                    <div style={{ padding: 20, paddingBottom: 0, border: "1px solid #ced4da", borderRadius: 5, background: "#fff", margin: 10 }}>
                        <h5 style={{ color: "#1b1b1b", fontWeight: "bold" }}> ໃຊ້ QR ທະນາຄານຂອງຮ້ານເອງ <span role="img" aria-label="bank">🏦</span></h5>
                        <div className="row">
                            <div className="col-6">
                                <Form.Group style={{ display: "flex", flexDirection: "column" }}>
                                    <h7 style={{ fontWeight: "bold" }}>ໃຊ້ງານ: <span style={{ fontWeight: "normal", color: cfUseOwnQr ? "green" : "red" }}>{cfUseOwnQr ? "ເປີດ" : "ປີດ"}</span></h7>
                                    <ReactSwitch
                                        checked={cfUseOwnQr}
                                        onChange={() => setCfUseOwnQr(!cfUseOwnQr)}
                                        onColor="#bfbdc7"
                                        onHandleColor="#422f90"
                                        handleDiameter={20}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                        height={28}
                                        width={55}
                                        className="react-switch"
                                        id="material-switch-own-qr"
                                    />
                                </Form.Group>
                                <div style={{ height: 20 }} />
                                <div>
                                    <Button style={{ background: COLOR_APP, color: "#ffff", width: "100%" }} onClick={_saveSetting}
                                        disabled={loadingCreateSetting || loadingUpdateSetting} >
                                        {loadingCreateSetting || loadingUpdateSetting ? "ກຳລັງບັນທຶກ..." : "ບັນທຶກ"}
                                    </Button>
                                </div>
                            </div>
                            <div className="col-6">
                                <h7>ຄໍາແນະນໍາການຕັ້ງຄ່າ</h7>
                                <p style={{ margin: 0, fontSize: 14 }}>-ຖ້າປິດ (ແນະນຳ): ລະບົບສ້າງ QR ຕາມຍອດເງິນຂອງແຕ່ລະອໍເດີ້ ແລະ ຢືນຢັນການຈ່າຍໃຫ້ອັດຕະໂນມັດ</p>
                                <p style={{ margin: 0, fontSize: 14 }}>-ຖ້າເປີດ: ສົ່ງຮູບ QR ທະນາຄານຂອງຮ້ານ (ຕັ້ງຢູ່ໜ້າ “ທະນາຄານ”) ລູກຄ້າຕ້ອງພິມຍອດເອງ ແລະ ສົ່ງສະລິບມາໃຫ້ຮ້ານກວດ</p>
                                <p style={{ margin: 0, fontSize: 14, color: "#b00" }}>-ໝາຍເຫດ: ຖ້າໃຊ້ QR ຂອງຮ້ານເອງ ລະບົບຈະບໍ່ສາມາດຢືນຢັນການຈ່າຍເງິນໃຫ້ອັດຕະໂນມັດໄດ້</p>
                            </div>
                        </div>
                        <div style={{ height: 20 }} />
                    </div>
                    ) : null}
                    {/* // TODO Setting Auto Reply Order Confirm */}
                    <div style={{ padding: 20, paddingBottom: 0, border: "1px solid #ced4da", borderRadius: 5, background: "#fff", margin: 10 }}>
                        <h5 style={{ color: "#1b1b1b", fontWeight: "bold" }}> ຕັ້ງຄ່າການ ລະຫັດສີ້ນຄ້າ ທີ່ບໍ່ຂື້ນຕົ້ນດ້ວຍ 0 <span role="img" aria-label="auto-receive">⌨️⌨️</span></h5>
                        <div className="row">
                            <div className="col-6">
                                
                                <Form.Group style={{ display: "flex", flexDirection: 'column' }}>
                                    <h7 style={{ fontWeight: 'bold' }}>ໃຊ້ງານ: <span style={{ fontWeight: 'normal', color: sCodeStartWithO ? "green" : "red" }}>{sCodeStartWithO ? "ເປີດ" : "ປີດ"}</span></h7>
                                    <ReactSwitch
                                        checked={sCodeStartWithO}
                                        onChange={() => setSCodeStartWithO(!sCodeStartWithO)}
                                        onColor="#bfbdc7"
                                        onHandleColor="#422f90"
                                        handleDiameter={20}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                        height={28}
                                        width={55}
                                        className="react-switch"
                                        id="material-switch"
                                    />
                                </Form.Group>
                                <div style={{ height: 20 }} />
                                <div style={{}}>
                                    <Button style={{ background: COLOR_APP, color: "#ffff", width: "100%" }} onClick={_saveSetting}
                                        disabled={loadingCreateSetting || loadingUpdateSetting} >
                                        {loadingCreateSetting || loadingUpdateSetting ? "ກຳລັງບັນທຶກ..." : "ບັນທຶກ"}
                                    </Button>
                                </div>
                            </div>
                            <div className="col-6">
                                <h7>ຄໍາແນະນໍາການຕັ້ງຄ່າ</h7>
                                <p style={{ margin: 0, fontSize: 14, }}>-ຖ້າຫາກຕັ້ງຄ່ານີ້ເປີດ: ການສ້າງ ລະຫັດສີ້ນຄ້າ ທີ່ບໍ່ຂື້ນຕົ້ນດ້ວຍ 0 ຈະເຮັດວຽກທັນທີ່</p>
                                <p style={{ margin: 0, fontSize: 14, }}>-ຖ້າຫາກຕັ້ງຄ່ານີ້ປີດ: ການສ້າງລະຫັດສີ້ນຄ້າຈະຂື້ນຕົ້ນດ້ວຍ 0 ໃຫ້ໂດຍອັດຕະໂນມັດ</p>
                            </div>
                        </div>
                        <div style={{ height: 20 }} />
                    </div>

                    {/* // TODO Setting Auto Reply Order Confirm */}
                    <div style={{ padding: 20, paddingBottom: 0, border: "1px solid #ced4da", borderRadius: 5, background: "#fff", margin: 10 }}>
                        <h5 style={{ color: "#1b1b1b", fontWeight: "bold" }}> ຕັ້ງຄ່າ ເກັບປາຍທາງ ສຳລັບ ເຊວເພສ<span role="img" aria-label="auto-receive">⌨️⌨️</span></h5>
                        <div className="row">
                            <div className="col-6">
                                
                                <Form.Group style={{ display: "flex", flexDirection: 'column' }}>
                                    <h7 style={{ fontWeight: 'bold' }}>ໃຊ້ງານ: <span style={{ fontWeight: 'normal', color: sp_cod ? "green" : "red" }}>{sp_cod ? "ເປີດ" : "ປີດ"}</span></h7>
                                    <ReactSwitch
                                        checked={sp_cod}
                                        onChange={() => setSp_cod(!sp_cod)}
                                        onColor="#bfbdc7"
                                        onHandleColor="#422f90"
                                        handleDiameter={20}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                        height={28}
                                        width={55}
                                        className="react-switch"
                                        id="material-switch"
                                    />
                                </Form.Group>
                                <div style={{ height: 20 }} />
                                <div style={{}}>
                                    <Button style={{ background: COLOR_APP, color: "#ffff", width: "100%" }} onClick={_saveSetting}
                                        disabled={loadingCreateSetting || loadingUpdateSetting} >
                                        {loadingCreateSetting || loadingUpdateSetting ? "ກຳລັງບັນທຶກ..." : "ບັນທຶກ"}
                                    </Button>
                                </div>
                            </div>
                            <div className="col-6">
                                <h7>ຄໍາແນະນໍາການຕັ້ງຄ່າ</h7>
                                <p style={{ margin: 0, fontSize: 14, }}>-ຖ້າຫາກຕັ້ງຄ່ານີ້ເປີດ:ຈະເປັນການເປີດການເກັບເງິນປາຍທາງ ຂອງເຊວເພສ</p>
                                <p style={{ margin: 0, fontSize: 14, }}>-ຖ້າຫາກຕັ້ງຄ່ານີ້ປີດ: ຈະເປັນການປິດການເກັບເງິນປາຍທາງ</p>
                            </div>
                        </div>
                        <div style={{ height: 20 }} />
                    </div>
                </>
            )}
        </div>
    );
}

export default SettingOther;